<div class="footer p-4">
  <div class="container">
    <p>Copyright © 2019 CC APPS PTY LTD | <a routerLink="/privacy">privacy</a> | <a routerLink="/terms">terms & conditions</a> </p>
  </div>
</div>
